import * as React from 'react';
import { CSSProperties } from 'react';
import { Row, Col, Container, Button } from 'reactstrap';

import './PortfolioListItem.css';

type portfolioProps = {
    id: number,
    title: string,
    client: string,
    date: string,
    excerpt: any,
    image_url: string,
    background_url: string,
    background_color: string,
    links: Array<{
        title: string,
        url: string,
    }>,
    flip_columns: boolean
};

export class PortfolioListItem extends React.Component<portfolioProps, {}> {
    render() {

      const css: CSSProperties = {};
      css.backgroundColor = this.props.background_color;
      css.backgroundImage = "url(" + this.props.background_url + ")";

      return (

        <article className="portfolio-item negative multi-bg" style={css}>
          <Container>
            <Row>
              <Col xs="12" sm="12" lg={{ size: 8 }} className={"pb-5 order-lg-" + ( this.props.flip_columns ? 2 : 1 )}>
                <img src={this.props.image_url} alt="" className="portfolio-image wow fadeIn" />
              </Col>
              <Col xs="12" sm="12" lg={{ size: 4 }} className={"order-lg-" + ( this.props.flip_columns ? 1 : 2 )}>
                <header>
                  <h1>{this.props.title}</h1>
                  <small className="byline">{this.props.client}, {this.props.date}</small>
                </header>
                <div className="excerpt">
                  {this.props.excerpt}
                </div>
                <footer>
                  <ul className="links">
                    { this.props.links.map( link => {
                        return (
                          <li><a href={link.url}><Button color="primary">{link.title}</Button></a></li>
                        );
                      })
                    }
                  </ul>
                </footer>
              </Col>

            </Row>
          </Container>
        </article>
      );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/portfolio/portfolio-list-item/PortfolioListItem.tsx